<script lang="ts">
  import { Avatar as AvatarPrimitive } from "bits-ui"

  import { cn } from "@/utils"

  let {
    ref = $bindable(null),
    class: className,
    ...restProps
  }: AvatarPrimitive.FallbackProps = $props()
</script>

<AvatarPrimitive.Fallback
  bind:ref
  data-slot="avatar-fallback"
  class={cn(
    "bg-muted flex size-full items-center justify-center rounded-full",
    className,
  )}
  {...restProps}
/>
